import {FreeDeliverySection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/basket_mov.types';
import {COLORS} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import {MovProgress, MovProgressProps} from '../MovProgress/MovProgress';
import {FreeDeliverySectionInfoMessage} from './FreeDeliverySectionInfoMessage';
import {useShouldShowMovReachedLabel} from './utils/useShouldShowMovReachedLabel';

interface FreeDeliverySectionProps
  extends Pick<
    MovProgressProps,
    | 'ProgressMoreInfoLayoutComponent'
    | 'padded'
    | 'showSubtitleAboveProgressBar'
    | 'onMoreInfoIconClick'
  > {
  className?: string;
  freeDeliverySection?: FreeDeliverySection;
  isMovReached?: boolean;
}

export const FreeDeliverySectionView = ({
  className,
  ProgressMoreInfoLayoutComponent,
  freeDeliverySection,
  padded,
  showSubtitleAboveProgressBar,
  onMoreInfoIconClick,
  isMovReached,
  ref,
}: FreeDeliverySectionProps & {ref?: React.Ref<HTMLDivElement>}) => {
  const {movProgressRef, shouldShowMovReachedLabel} =
    useShouldShowMovReachedLabel();

  if (!freeDeliverySection?.type) {
    return null;
  }

  switch (freeDeliverySection.type.$case) {
    case 'progressUntilFreeDeliverySection': {
      const freeDeliveryProgress =
        freeDeliverySection.type.progressUntilFreeDeliverySection;

      return (
        <Wrapper className={className} ref={ref} $isMovReached={isMovReached}>
          <MovProgress
            ref={movProgressRef}
            title={freeDeliveryProgress.freeDeliveryLabel}
            subtitle={freeDeliveryProgress.amountUntilFreeShipping}
            ProgressMoreInfoLayoutComponent={ProgressMoreInfoLayoutComponent}
            moreInfoDescription={freeDeliveryProgress.moreInfoDescription}
            moreInfoTitle={freeDeliveryProgress.moreInfoTitle}
            progress={freeDeliveryProgress.progress}
            padded={padded}
            showSubtitleAboveProgressBar={showSubtitleAboveProgressBar}
            onMoreInfoIconClick={onMoreInfoIconClick}
          />
        </Wrapper>
      );
    }
    case 'infoMessage': {
      const infoMessage = freeDeliverySection.type.infoMessage;
      if (!shouldShowMovReachedLabel) {
        return null;
      }

      return (
        <Wrapper className={className}>
          <FreeDeliverySectionInfoMessage infoMessage={infoMessage} />
        </Wrapper>
      );
    }
    default:
      return null;
  }
};

const Wrapper = styled.div<{$isMovReached?: boolean}>`
  ${props =>
    props.$isMovReached &&
    css`
      border-top: 1px solid ${COLORS['Outline.Grey']};
      border-bottom: 1px solid ${COLORS['Outline.Grey']};
    `}
`;
